import { OdinController } from '@myosh/odin-components';
import type { Control } from 'react-hook-form';
import type { InvitationFieldProps } from './invitation-field.component';
import InvitationField from './invitation-field.component';

interface HfInvitationFieldProps extends InvitationFieldProps {
  control?: Control;
  name?: string;
}

function HfInvitationField({
  name = 'invitation',
  control,
  value,
  onChange,
  readOnly,
  required,
  recordId,
  permissions,
  saveRecord,
  updateLastChangeValue,
  setFormButtonsState,
}: HfInvitationFieldProps) {
  return (
    <OdinController
      name={name}
      control={control}
      defaultValue={value}
      onChange={onChange}
      render={({ field: { value }, fieldState: { error } }) => (
        <InvitationField
          readOnly={readOnly}
          required={required}
          error={error?.message}
          value={value}
          recordId={recordId}
          permissions={permissions}
          saveRecord={saveRecord}
          updateLastChangeValue={updateLastChangeValue}
          setFormButtonsState={setFormButtonsState}
        />
      )}
    />
  );
}

export default HfInvitationField;
